var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Numbers"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(0,0,0)",
    fontFamily: "ArialMT, Arial",
    fontSize: 18,
    transform: "translate(31.995 -141.877)"
  }, "6", /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 124
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 248
  }, "26"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 372
  }, "36"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 496
  }, "46"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 620
  }, "56"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 744
  }, "66"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 868
  }, "76"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 992
  }, "86"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 1116
  }, "96"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1240
  }, "106"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.074em",
    x: -9.343,
    y: 1364
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: -0.668,
    y: 1364
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1488
  }, "126"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1612
  }, "136"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1736
  }, "146"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1860
  }, "156"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1984
  }, "166"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2108
  }, "176"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2232
  }, "186"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2356
  }, "196"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2480
  }, "206"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2604
  }, "216"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2728
  }, "226"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2852
  }, "236"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2976
  }, "246"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3100
  }, "256"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3224
  }, "266"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3348
  }, "276"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3472
  }, "286"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3596
  }, "296")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62 38.97a1 1 0 0 1 -1-1v-2.91a1 1 0 0 1 2 0v2.91a1 1 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 72h-50a1 1 0 0 1 -1-1v-68a1 1 0 0 1 1-1h36a1 1 0 0 1 .707.293l14 14a1 1 0 0 1 .293.707v11.06a1 1 0 1 1 -2 0v-10.646l-13.414-13.414h-34.586v66h48v-15.06a1 1 0 0 1 2 0v16.06a1 1 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 48.94a1 1 0 0 1 -1-1v-2.97a1 1 0 0 1 2 0v2.97a1 1 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 18h-14a1 1 0 0 1 -1-1v-14a1 1 0 0 1 2 0v13h13a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 15h-22a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 24h-36a1 1 0 0 1 0-2h36a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 33h-36a1 1 0 0 1 0-2h36a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 52a5.67 5.67 0 1 1 5.669-5.669 1 1 0 0 1 -2 0 3.669 3.669 0 1 0 -3.669 3.669 1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 61.339a5.676 5.676 0 0 1 -5.669-5.67 1 1 0 0 1 2 0 3.669 3.669 0 1 0 3.669-3.669 1 1 0 0 1 0-2 5.67 5.67 0 0 1 0 11.339z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 63.344a1 1 0 0 1 -1-1v-22.688a1 1 0 0 1 2 0v22.688a1 1 0 0 1 -1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.eb85fc248d1468f01dbe21519cb53f1a.svg";
export { ForwardRef as ReactComponent };